export default __webpack_public_path__ + "static/media/second-step-reihenmittelhaus.767f538c.svg";